@if (!item.hidden) {
	<span class="navigation-section-text">{{ item.translate ? (item.translate | translate) : item.title }}</span>
	<!-- More icon in collapsed menu -->
	<fa-icon [icon]="'minus'"></fa-icon>
}
